/* Auto-generated from inline schema 2025-08-29T08:39:05.771Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
